const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // async fetchList({ commit, rootGetters }, payload) {
  //   try {
  //     const defaultPageable = rootGetters['table/defaultPageable'];
  //     const sortBy = payload.sortBy?.[0] ? `${payload.sortBy?.[0]}|${payload.sortDesc?.[0] ? 'desc' : 'asc'}` : null;
  //     const params = {
  //       size: defaultPageable.limit,
  //       page: defaultPageable.currentPage - 1,
  //       search: defaultPageable.search,
  //       sortBy
  //     };

  //     let url = `/api/student-grade`;

  //     const {
  //       data: { data }
  //     } = await window.axios.get(url, { params });
  //     const { content, totalPages, totalElements } = data;

  //     commit('SET_ITEM', content);
  //     commit('table/SET_DEFAULT_TOTAL_PAGES', totalPages, { root: true });
  //     commit('table/SET_DEFAULT_TOTAL_ELEMENTS', totalElements, { root: true });
  //   } catch (err) {
  //     throw err;
  //   }
  // },

  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/student-grade?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchStudentDetail({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/student-grade/grade/${payload}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchStudentDetailIndex({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/student-grade/student-list/grade/${payload}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchStudent({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/student-grade/student-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchStudentEdit({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/student-grade/${payload}/student-list-all`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchClass({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/student-grade/grade-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchClassUpdate({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/student-grade/grade-list/${payload}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async save({ commit }, payload) {
    var paylod = payload;
    // for (var i = 0; i < paylod.courses.length; i++) {
    //   delete paylod.courses[i]['name'];
    // }
    // console.info(paylod);
    return window.axios.post('/api/student-grade', paylod);
  },
  // eslint-disable-next-line no-unused-vars
  async update({ commit }, payload) {
    var paylod = payload;
    // for (var i = 0; i < paylod.courses.length; i++) {
    //   delete paylod.courses[i]['name'];
    // }
    // console.info(paylod);
    return window.axios.put(`/api/student-grade/grade/${paylod.gradeId}`, paylod);
  },

  // eslint-disable-next-line no-unused-vars
  downloadTemplate({ commit }) {
    return window.axios.get(`/api/student-grade/template`, { responseType: 'arraybuffer' });
  },
  // eslint-disable-next-line no-unused-vars
  importData({ commit }, payload) {
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    return window.axios.post(`/api/student-grade/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/student-grade/grade/${payload.gradeId}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
